<template>
  <button
    class="btn"
    ref="exportbtn"
    :class="{
      'btn-success': success,
      'btn-outline-primary': !success,
    }"
    @click="handleExportCSV"
    :disabled="loading"
    data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('Export with enabled filters')"
  >
    <span v-if="success">{{ 'Download CSV' | translate }}</span>

    <span
      v-else-if="loading"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>

    <span v-else>{{ 'Export CSV' | translate }}</span>
  </button>
</template>

<script>
export default {
  props: ['link', 'filters'],
  data() {
    return {
      date: null,
      success: false,
      loading: false,
      csvData: null,
    }
  },
  mounted() {
    bootstrap.Tooltip.getOrCreateInstance(this.$refs.exportbtn).enable()
  },
  methods: {
    handleExportCSV() {
      if (this.success && this.csvData) {
        this.download(this.csvData)
      } else {
        this.fetchData()
      }
    },
    fetchData() {
      this.loading = true
      axios
        .post(this.link, this.filters)
        .then((response) => {
          this.date = Date.now()
          this.csvData = response.data
          this.loading = false
          this.success = true
        })
        .catch((error) => {
          this.loading = false
          this.success = false
          if (error.response.status === 429) {
            iziToast.warning({
              title: this.$t('Warning'),
              message: this.$t('You can only make one export per minute'),
              position: 'bottomLeft',
            })
          }
        })
    },
    download(data) {
      let csvData = new Blob([data], {
        type: 'text/csv;charset=utf-8;',
      })
      let csvURL = null
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, `skyier_export_${this.date}.csv`)
      } else {
        csvURL = window.URL.createObjectURL(csvData)
      }

      let tempLink = document.createElement('a')
      tempLink.href = csvURL
      tempLink.setAttribute('download', `skyier_export_${this.date}.csv`)
      tempLink.click()
    },
  },
}
</script>

<style></style>
